import { NAME } from './message-state-name';

export const getMessage = state => state[NAME];
